import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import PeriodRepository from '../Repositories/PeriodRepository'

class DataTableBloc {

    rowtableChannel = new Subject();
    repository = new PeriodRepository()

    constructor() {
        this.rowtableChannel.next({status: apiResponse.INITIAL})
    }

    fetchRowTable = async (query, cancelToken) => {
        try {
            this.rowtableChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchRowTable(query, cancelToken).then((result) => {
                this.rowtableChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.rowtableChannel.next({status: apiResponse.ERROR, data: error})
            })   
        } catch (error) {
            
        }
    }
}

export default DataTableBloc
